import React, { createContext } from 'react'

import { getUrlParameter } from '../helpers'
// import appeal from '../data/appeal'

export const Context = createContext<any>(undefined)

interface Props {
  children: React.ReactNode;
}

export const DonationProvider: React.FC<Props> = ({ children }) => {

  const paramAmount = Number(getUrlParameter('amount'))
  const paramType = getUrlParameter('type')

  const showLoading = () => {
    (document as any).getElementById('loading').classList.add('show');
    (document as any).getElementById('body').classList.add('oh');
  }

  const hideLoading = () => {
    (document as any).getElementById('loading').classList.remove('show');
    (document as any).getElementById('body').classList.remove('oh');
  }

  let state = {
    paramAmount,
    paramType,
    showLoading,
    hideLoading
  }

  return <Context.Provider value={state}>{children}</Context.Provider>

}

export default Context